import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Button from 'sd-ui/dist/commonjs/components/Button/Button';
import Icon from '../icon';
import { trackAdobeFeature } from '../../utils/trackers/adobe';

export default class FitAndRotate extends Component {
  constructor() {
    super();
    this.handleRotate = this.handleRotate.bind(this);
    this.handleFitToWidth = this.handleFitToWidth.bind(this);
  }

  handleRotate() {
    const { rotate, activePageIndex } = this.props;
    trackAdobeFeature('document-rotate');
    rotate(activePageIndex);
  }

  handleFitToWidth() {
    const { fitToWidthClick } = this.props;
    trackAdobeFeature('document-fit-to-width');
    fitToWidthClick();
  }

  render() {
    const { stayFitToWidth } = this.props;
    const fitToWidthClass = classnames({ active: stayFitToWidth });

    return (
      <div className="fitAndRotate viewer-controls u-hide-from-print">
        <Button
          className={fitToWidthClass}
          onClick={this.handleFitToWidth}
          tabIndex="0"
          title="Toggle fit to screen width"
          aria-pressed={stayFitToWidth}
          id="fit-to-width-button"
        >
          <Icon.Expand />
        </Button>
        <Button
          tabIndex="0"
          title="Rotate current page clockwise"
          onClick={this.handleRotate}
          id="rotate-button"
        >
          <Icon.Refresh />
        </Button>
      </div>
    );
  }
}

FitAndRotate.defaultProps = {
  activePageIndex: 0,
  stayFitToWidth: false,
};

FitAndRotate.propTypes = {
  rotate: PropTypes.func.isRequired,
  fitToWidthClick: PropTypes.func.isRequired,
  stayFitToWidth: PropTypes.bool,
  activePageIndex: PropTypes.number,
};
